export function getWidgetParameters(widgets: any[], widgetKey: string) {
  const widget = widgets.find((w) => w.key === widgetKey);
  const params = widget?.widgetProperty?.widgetProperties?.parameterConfig?.[0]?.parameters ?? [];
  return params.map((param: any) => ({
    key: param.name,
    name: param.description || param.name,
    color: param.lineColor || param.markerColor,
    shape: param.markerType,
    seleceted: param.selected,
  }));
}

export function mapXYArrays(data: any, keys: string[]) {
  if (!data) return data;
  const result = Array.isArray(data) ? data.map((d) => ({ ...d })) : { ...data };

  const process = (obj: any) => {
    keys.forEach((key) => {
      if (Array.isArray(obj[key])) {
        obj[key] = obj[key].map((pt: any) =>
          Array.isArray(pt) ? pt : pt && typeof pt === 'object' && 'X' in pt && 'Y' in pt ? [pt.X, pt.Y] : pt,
        );
      }
    });
  };

  if (Array.isArray(result)) {
    result.forEach(process);
  } else {
    process(result);
  }
  return result;
}
